import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/AssignProfileScreen.css';
import { fetchCategories } from '../../../apiservices/axiosservice/subscriberservice';

interface BusinessCategory {
  categoryId: string;
  categoryName: string;
  categoryIcon: string;
}

const AssignProfileScreen: React.FC = () => {
  const [businessCategories, setBusinessCategories] = useState<BusinessCategory[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBusinessCategories = async () => {
      try {
        const response = await fetchCategories();
        if (response && response.data) setBusinessCategories(response.data);
      } catch (error) {}
    };
    fetchBusinessCategories();
  }, []);

  const handleCategoryToggle = (categoryId: string) => {
    setSelectedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleContinue = () => {
    navigate('/subscription-plan', { state: { categories: selectedCategories } });
  };

  return (
    <div className="assign-profile-page">
      <div className="assign-profile-wrapper">
        <div className="assign-profile-header">
          <span className="assign-profile-icon">😊</span>
          <h1>What interests you?</h1>
        </div>

        <div className="assign-categories-grid">
          {businessCategories.map((category) => (
            <div
              key={category.categoryId}
              className={`assign-category-card ${
                selectedCategories.includes(category.categoryId) ? 'selected' : ''
              }`}
              onClick={() => handleCategoryToggle(category.categoryId)}
            >
              <span className="assign-category-icon">{category.categoryIcon}</span>
              <span className="assign-category-name">{category.categoryName}</span>
            </div>
          ))}
        </div>

        <div className="assign-profile-actions">
          <button className="skip-btn" onClick={handleContinue}>
            Skip for now
          </button>
          <button
            className="continue-btn"
            onClick={handleContinue}
            disabled={selectedCategories.length === 0}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignProfileScreen;
